module.exports = __webpack_public_path__ + "static/img/1-12.31844da.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/1/1-12.png
// module id = K19a
// module chunks = 0